export class ParameterDetail {
	productname: string;
	parameterId: number;
	columns: any[];
	data: any[];
}
